import type {
  ClientDataDto,
  DeleteUserItemDto,
  InternalUserCreateDto,
  InternalUserDto,
  InternalUserProfileDto,
  InternalUserUpdateDto,
  UserDetailsDto,
  UserDetailsUserDto,
} from '../dto';
import type {
  ClientData,
  CreateUserRequest,
  DeleteUserParams,
  InternalUser,
  InternalUserProfile,
  UpdateUserRequest,
  UserDetails,
  UserDetailsUser,
} from '../models';

export const mapInternalUserDtoToModel = (
  dto: InternalUserDto,
): InternalUser => ({ ...dto });

export const mapInternalUsersListDtoToModel = (
  dto: InternalUserDto[],
): InternalUser[] => dto.map(mapInternalUserDtoToModel);

export const mapInternalUserProfileDtoToModel = (
  dto: InternalUserProfileDto,
): InternalUserProfile => ({ ...dto });

export const mapInternalUserProfilesListDtoToModel = (
  dtos: InternalUserProfileDto[],
): InternalUserProfile[] => dtos.map(mapInternalUserProfileDtoToModel);

export const mapCreateUserRequestToDto = (
  request: CreateUserRequest,
): InternalUserCreateDto[] => [
  {
    rfc: request.rfc,
    name: request.firstName,
    fathersLastName: request.fathersLastName,
    mothersLastName: request.mothersLastName,
    amibRegistration: request.amib,
    cv: '',
    email: request.email,
    role: request.profile?.label ?? '',
    telephones: [],
    street: '',
    interiorNumber: '',
    exteriorNumber: '',
    zipCode: '',
    suburb: '',
    city: '',
    state: '',
  },
];

export const mapUpdateUserRequestToDto = (
  request: UpdateUserRequest,
): InternalUserUpdateDto[] => [
  {
    userId: request.userId,
    amibRegistration: request.amib,
    email: request.email,
    rfc: request.rfc,
    name: request.firstName,
    fathersLastName: request.fathersLastName,
    mothersLastName: request.mothersLastName,
    role: request.profile.label,
    roleId: request.profile.sequenceId,
  },
];

export const mapDeleteUserParamsToDto = (
  params: DeleteUserParams,
): DeleteUserItemDto[] => [{ userId: params.userId, name: params.name }];

const mapUserDetailsUserDtoToModel = (
  dto: UserDetailsUserDto,
): UserDetailsUser => ({ ...dto });

const mapClientDataDtoToModel = (dto: ClientDataDto): ClientData => ({
  ...dto,
});

export const mapUserDetailsDtoToModel = (dto: UserDetailsDto): UserDetails => ({
  status: dto.status,
  message: dto.message,
  user: mapUserDetailsUserDtoToModel(dto.user),
  totalClients: dto.totalClients,
  clientData: dto.clientData.map(mapClientDataDtoToModel),
});
